import { Ban, CheckCircle2, Clock, Layers, PauseCircle, Send } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { useI18n } from '@/lib/i18n';
import type { ChangeStatus } from '@/lib/changes-api';

/**
 * PLAKIETKA STANU OPERACJI CONFIG-DOWN — JEDNA dla wszystkich ekranów.
 *
 * ⚠️ POWSTAŁA Z ROZJAZDU DWÓCH RENDEROWAŃ, nie z chęci porządku. Ekran „Zmiany" pokazywał
 * prawdziwy stan (stepper, plakietka, powód odmowy), a edytor config-down rysował na sztywno
 * „w kolejce" — bez patrzenia na `status`. Ta sama operacja wyglądała więc w dwóch miejscach
 * inaczej, a w edytorze WYGLĄDAŁA NA ZAMROŻONĄ, choć agent dawno ją wykonał albo odrzucił.
 *
 * ⚠️ `FAILED` NIE ZNACZY „AWARIA" — najczęstszy powód to odmowa wartownika, czyli wiersz zmieniony
 * w SPSUI po ostatnim odczycie agenta. Dlatego wszędzie, gdzie stoi ta plakietka, musi dać się
 * pokazać też POWÓD; sama plakietka nie wystarcza do decyzji, co dalej.
 */
/** Ikony etapów — eksportowane, bo stepper w „Zmianach" rysuje z nich cały tor, nie tylko stan bieżący. */
export const IKONA_STANU: Record<ChangeStatus, typeof Clock> = {
  QUEUED: Clock,
  SENT: Send,
  APPLIED: Layers,
  CONFIRMED: CheckCircle2,
  FAILED: Ban,
  SUPERSEDED: PauseCircle,
};

export function StatusZmiany({ status }: { status: ChangeStatus }) {
  const { t } = useI18n();
  const Icon = IKONA_STANU[status];
  const variant =
    status === 'CONFIRMED' ? 'success' : status === 'FAILED' ? 'destructive' : status === 'QUEUED' ? 'warning' : 'neutral';
  return (
    <Badge variant={variant} title={t(`chg.statusHint.${status}`)}>
      <Icon className="size-3" />
      {t(`chg.status.${status}`)}
    </Badge>
  );
}
